"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.TitlesHeadline = void 0;
require("./TitlesHeadline.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _GridContainer = _interopRequireDefault(require("../GridContainer/GridContainer"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * TitleHeadline component
 *
 * @method
 * @param { TitlesHeadlineProps} props
 * @returns TitlesHeadline
 */

const TitlesHeadline = props => {
  const {
    backgroundColor,
    headline,
    headlineTag = defaultProps.headlineTag,
    subheadline,
    textAlignment
  } = props;
  if (!headline) {
    return null;
  }
  const hasBackgroundColor = backgroundColor && backgroundColor !== 'background-default';
  const componentClassName = (0, _classnames.default)('pal-c-TitlesHeadline', {
    [`pal-c-TitlesHeadline__alignment--${textAlignment}`]: textAlignment,
    [`pal-c-TitlesHeadline--${backgroundColor}`]: backgroundColor,
    [`pal-c-TitlesHeadline--hasBackgroundColor`]: hasBackgroundColor
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesHeadline__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesHeadline__body--headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "headline-lg",
    htmlTag: headlineTag,
    textAlign: textAlignment,
    textColor: "content-default"
  }, headline)), subheadline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesHeadline__body--subheadline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "displayBody",
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: "content-default"
  }, subheadline)))));
};

/**
 * Property type definitions
 * @typedef TitlesHeadlineProps
 * @type {object}
 * @property {string} backgroundColor - text for the backgroundColor
 * @property {string} headline - headline text of the title
 * @property {string} headlineTag - headline tag of the title
 * @property {string} subheadline - subheadline tag of the title
 * @property {string} textAlignment - align the text (left or center)
 */
exports.TitlesHeadline = TitlesHeadline;
const propTypes = exports.propTypes = {
  backgroundColor: _propTypes.default.string,
  headline: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  subheadline: _propTypes.default.string,
  textAlignment: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag='h2' - headline tag of the title
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2'
};
TitlesHeadline.propTypes = propTypes;
var _default = exports.default = TitlesHeadline;